import React from "react";
import dropDownCloseIcon from "../../img/dropDownCloseIcon.svg";
import dropDownOpenIcon from "../../img/dropDownOpenIcon.svg";
import "./styles/faq.css";

const FaqAccordion = (props) => {
    const handleAccordionClick = () => {
        props.recordAccordionId(props.identifier);
    };

    return (
        <div onClick={handleAccordionClick} className="dsa-accordion-wrapper">
            <div className={(props.isOpen ? "dsa-accordion-background" : " ") + " dsa-accordion-item"}>
                {" "}
                <div className="dsa-accordion-question">
                    <h3>{props.accordionData.question}</h3>
                    {props.isOpen ? <img src={dropDownCloseIcon} alt="" /> : <img src={dropDownOpenIcon} alt="" />}
                </div>
                <div className={(props.isOpen ? "dsa-accodrion-show" : " ") + " dsa-accodrion-content"}>
                    <p>{props.accordionData.answer}</p>
                </div>
            </div>
        </div>
    );
};

export default FaqAccordion;
